export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12783.251e66da.jpg";